import React from 'react';
import { alpha, Typography, useTheme } from '@mui/material';

const FolioWorkflowLogo = ({ height = 22, variant = 'dark' }) => {
	const theme = useTheme();
	const onDark = variant === 'dark';
	const fontSize = `${height}px`;

	const lightenedText = onDark
		? alpha(theme.palette.folioWhite, 0.55)
		: alpha(theme.palette.darkModePaper, 0.55);

	return (
		<Typography
			component='span'
			sx={{
				fontSize,
				fontWeight: 700,
				lineHeight: 1,
				color: onDark ? theme.palette.folioWhite : theme.palette.darkModePaper,
				letterSpacing: '0.01em',
				whiteSpace: 'nowrap',
			}}
		>
			Folio
			<Typography
				component='span'
				sx={{
					fontSize,
					fontWeight: 700,
					fontStyle: 'italic',
					lineHeight: 1,
					color: lightenedText,
				}}
			>
				Workflow
			</Typography>
		</Typography>
	);
};

export default FolioWorkflowLogo;
